import { invoiceService } from "@/services/InvoiceService";
import {toast} from "vue3-toastify";
import {i18n} from "@/lang";

const state = {
    invoiceData: [],
    invoiceRequestMessage: "",
    isLoadingInvoiceRequest: false,
    lastStartDate: 0,
    lastEndDate: 0
};

const actions = {
    getInvoiceData({dispatch, commit}, { startDate, endDate }){
        commit(mutations.setLoadingRequest.name, true);
        invoiceService.getInvoices(startDate, endDate)
            .then((response) => {
                commit('setLoadingRequest', false);
                commit(mutations.setInvoiceData.name, response.data);
                commit(mutations.setLastQuery.name, { startDate, endDate });
            })
            .catch((error) => {
                commit(mutations.setLoadingRequest.name, false, error);
            });
    },
    getDownloadInvoice({dispatch, commit}, invoiceId){
        commit(mutations.setLoadingRequest.name, true);
        invoiceService.getDownloadInvoice(invoiceId)
            .then((response) => {
                const urlOpen = response?.data?.downloadUrl;
                window.open(urlOpen)
            })
            .catch((error) => {
                commit("setLoadingRequest", { loading: false });
            });
    },
    setInvoicePaid({dispatch, commit}, invoiceId){
        commit(mutations.setLoadingRequest.name, true);
        invoiceService.setInvoiceToPaid(invoiceId)
            .then((response) => {
                toast.success(i18n.global.t("toast.successEdit"));
                commit('setLoadingRequest', false);
                dispatch('getInvoiceData', { startDate: state.lastStartDate, endDate: state.lastEndDate });
            })
            .catch((error) => {
                toast.error(i18n.global.t("toast.errorEdit"));
                commit(mutations.setLoadingRequest.name, false, error);
            });
    },
    setInvoiceUnpaid({dispatch, commit}, invoiceId){
        commit(mutations.setLoadingRequest.name, true);
        invoiceService.setInvoiceToUnpaid(invoiceId)
            .then((response) => {
                toast.success(i18n.global.t("toast.successEdit"));
                commit('setLoadingRequest', false);
                dispatch('getInvoiceData', { startDate: state.lastStartDate, endDate: state.lastEndDate });
            })
            .catch((error) => {
                toast.error(i18n.global.t("toast.errorEdit"));
                commit(mutations.setLoadingRequest.name, false, error);
            });
    },
    sendInvoiceReminder({dispatch, commit}, invoiceId){
        commit(mutations.setLoadingRequest.name, true);
        invoiceService.sendInvoiceReminder(invoiceId)
            .then((response) => {
                toast.success(i18n.global.t("toast.successEdit"));
                commit('setLoadingRequest', false);
                dispatch('getInvoiceData', { startDate: state.lastStartDate, endDate: state.lastEndDate });
            })
            .catch((error) => {
                toast.error(i18n.global.t("toast.errorEdit"));
                commit(mutations.setLoadingRequest.name, false, error);
            });
    }
}

const mutations = {
    setLoadingRequest(state, isLoading, message=''){
        state.invoiceRequestMessage = message;
        state.isLoadingInvoiceRequest = isLoading;
    },
    setInvoiceData(state, invoiceData){
        state.invoiceData = invoiceData;
    },
    setLastQuery(state, { startDate, endDate }) {
        state.lastStartDate = startDate;
        state.lastEndDate = endDate;
    }
}


export const invoice = {
    namespaced: true,
    state,
    actions,
    mutations
};